const defaultState = {
  user: {},
};

export const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SAVE_SESSION":
      try {
        localStorage.setItem("user", JSON.stringify(action.payload));
      } catch (error) {
        console.log("error: ", error);
      }

      return {
        ...state,
        user: action.payload,
      };

    case "REMOVE_SESSION":
      localStorage.removeItem("user");
      localStorage.removeItem("account");
      localStorage.removeItem("system");
      localStorage.removeItem("token");
      localStorage.removeItem("categories");
      sessionStorage.removeItem("oauth2-state-key");

      return defaultState;

    default:
      return state;
  }
};
